import { CSSProperties, FC, ReactNode } from 'react';

import {
  Button,
  Dialog,
  DialogContent,
  Typography,
} from '@beeline/design-system-react/extracted-styles';
import { sizeSpacingX4 } from '@beeline/design-tokens/js/tokens/globals/sizes';

import classes from './ConfirmationDialog.module.scss';

const actionsStyle: CSSProperties = {
  display: 'flex',
  gap: sizeSpacingX4,
};

interface ConfirmationDialogActionsProps {
  onOk: () => void;
  onCancel: () => void;
  okLabel: ReactNode;
  cancelLabel: ReactNode;
}

const ConfirmationDialogActions: FC<ConfirmationDialogActionsProps> = ({
  onCancel,
  onOk,
  okLabel,
  cancelLabel,
}) => {
  return (
    <div style={actionsStyle}>
      <Button variant='outlined' onClick={onCancel} data-testid='cancel'>
        {cancelLabel}
      </Button>
      <Button variant='contained' onClick={onOk} data-testid='ok'>
        {okLabel}
      </Button>
    </div>
  );
};

export interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onOk: () => void;
  onCancel: () => void;
  okLabel: ReactNode;
  cancelLabel: ReactNode;
  title: ReactNode;
  text: ReactNode;
}

export const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
  open,
  onCancel,
  onClose,
  onOk,
  okLabel,
  cancelLabel,
  title,
  text,
}) => {
  return (
    <Dialog open={open} onClose={onClose} className={classes.dialog}>
      <DialogContent
        title={title}
        footer={
          <ConfirmationDialogActions
            onOk={onOk}
            onCancel={onCancel}
            okLabel={okLabel}
            cancelLabel={cancelLabel}
          />
        }
      >
        <Typography variant='body3'>{text}</Typography>
      </DialogContent>
    </Dialog>
  );
};
